import { queryOptions, useQuery } from '@tanstack/react-query'

import { communityApi } from '../api/communityApi'

type TCommunityQueryOptions = {
  enabled?: boolean
}

export const communityQueryOptions = (id: number, options?: TCommunityQueryOptions) =>
  queryOptions({
    queryKey: ['community', id],
    queryFn: ({ signal }) => communityApi.getCommunity({ id }, { signal }),
    staleTime: 1000 * 60 * 2,
    enabled: options?.enabled,
  })

export const useCommunityQuery = (id: number, options?: TCommunityQueryOptions) =>
  useQuery(communityQueryOptions(id, options))
